import { useContext } from "react";
import { Context_UI } from "../../Contexts/Context_UI";
export default function UI_Section_Title({ id, style, Text, Icon, Margins }) {
    const UI = useContext(Context_UI);


    return (
        <>
            <div className="Section_Title" id={id} style={style} Margins={Margins ? "Active" : "Inactive"}>
                {Icon}
                <h2 className="General_Title">
                    {Text}
                </h2>
            </div>
        </>
    )
}

